<template>
  <div class="warehouse-receipt-management">
    <inout-record-dialog
      :visible="recordDialogVisible"
      :receipt-id="currentDetail.id"
      @update:visible="recordDialogVisible = $event"
    />
    <h2 style="padding: 0 16px">仓单管理</h2>

    <ProTable ref="proTableRef" :columns="tableColumns" :request="loadData">
      <template slot="operation" slot-scope="{ row, index }">
        <el-button type="text" @click="handleInoutWarehouseRecord(row)"
          >出入库记录</el-button
        >
        <el-button type="text" @click="handleAppointOutWarehouse(row)"
          >预约出库</el-button
        >
      </template>
    </ProTable>

    <!-- 贷款产品区域 -->
    <div class="loan-products">
      <div class="title">
        我要用钱
        <span class="more" @click="handleMore">更多>></span>
      </div>
      <div class="product-list">
        <div
          class="product-item"
          v-for="(product, index) in loanProducts"
          :key="index"
        >
          <div class="product-name">{{ product.name }}</div>
          <div class="bank-name">{{ product.bank }}</div>
          <div class="product-info">
            <p>
              最高额度:
              <span>
                {{
                  product.maxAmount >= 10000
                    ? (product.maxAmount / 10000).toFixed(2)
                    : product.maxAmount
                }}
                {{ product.maxAmount >= 10000 ? "万元" : "元" }}
              </span>
            </p>
            <p>
              最长期限:
              <span>{{ product.maxPeriod }}个月</span>
            </p>
            <p>
              年利率:
              <span>{{ product.rate }}%</span>
            </p>
          </div>
          <el-button
            style="width: 100%"
            type="primary"
            size="small"
            @click="viewLoanProductDetail(product)"
          >
            查看详情
          </el-button>
        </div>
      </div>
    </div>
    <!-- 预约出库弹窗 -->
    <AppointOutWarehouseModal
      ref="appointOutWarehouseModal"
      :receiptInfo="selectedReceiptInfo"
      @confirm="handleAppointConfirm"
    />
  </div>
</template>

<script>
import {
  getReceiptList,
  getReceiptDetailById,
  getGrainCategoryList,
  getLoanList,
} from "@/api/warehousingService";
import ProTable from "@/components/table/ProTable.vue";
import AppointOutWarehouseModal from "./AppointOutWarehouseModal.vue";
import { mapGetters, mapMutations } from "vuex";
import { getStore } from "@/js/utils/store";
import InoutRecordDialog from "./InoutRecordDialog.vue";
import { splitStringByStep } from "@/utils/strUtil.js";



export default {
  name: "WarehouseReceiptManagement",
  components: {
    ProTable,
    AppointOutWarehouseModal,
    InoutRecordDialog,
  },
  data() {
    return {
      //粮食类别
      grainCategoryList: [],
      //贷款列表
      loanList: [],
      //仓单列表
      receiptList: [],

      // 弹窗相关状态
      selectedReceiptInfo: null,

      //地区编码
      areaCode: "",
      //地区编码数组[51,5117,511703]控制header组件的地区回显
      areaCodeArr: [],
      recordDialogVisible: false,
      currentRecord: {},
      recordList: [],
      currentDetail: { id: "" },
    };
  },
  mounted() {
    this.fetchGrainCategoryList();
    this.fetchLoanList();
  },
  watch: {
    topSelectAreacode: {
      handler(newVal, oldVal) {
        this.fetchLoanList();
      },
    },
  },
  computed: {
    ...mapGetters(["topSelectAreacode"]),
    //动态粮食类别
    grainCategorySearchOptions() {
      const options = [
        ...this.grainCategoryList.map((item) => ({
          id: item.id || "0",
          label: item.name || "",
          children: (item.childrenCategory || []).map(child => ({
              id: child.id || "0",
              label: child.name || "",
            }))
        })),
      ];
      return options;
    },
    //动态仓单贷
    loanProducts() {

      return (
        this.loanList
          // 排序：loanTypeId=180 的项排在前面，其他项按原顺序
          .sort((a, b) => {
            if (a.loanTypeId == 180) return -1 // a 优先
            if (b.loanTypeId == 180) return 1 // b 优先
            return 0 // 保持原顺序
          })
          .map(item => ({
            name: item.loanType || '',
            bank: item.bankName || '',
            maxAmount: item.maxMoney || '',
            maxPeriod: item.maxTime || '',
            rate: item.minRate || '',
            financeProductId: item.financeProductId || ''
          }))
          // 取前6条
          .slice(0, 6)
      )
    },

    tableColumns() {
      return [
        {
          prop: "number",
          inTable: false,
          searchable: true,
          search: {
            el: "input",
            props: {
              placeholder: "请输入入库单号",
            },
          },
        },
        {
          prop: "companyName",
          inTable: false,
          searchable: true,
          search: {
            el: "input",
            props: {
              placeholder: "请输入仓储公司",
            },
          },
        },
        {
          prop: "categoryId",
          inTable: false,
          searchable: true,
          searchType: "select-group",
          search: {
            props: {
              placeholder: "请选择粮食类别",
            },
          },
          searchOptions: this.grainCategorySearchOptions,
        },
        { prop: "number", label: "入库单号", width: "180" },
        { prop: "grainCategoryName", label: "粮食类型", width: "100" },
        { prop: "grainCategoryLevel", label: "粮食级别", width: "100" },
        { prop: "companyName", label: "仓储公司", width: "250" },
        { prop: "totalWeight", label: "仓单总量(KG)", width: "120" },
        { prop: "dispatchedWeight", label: "已出库(KG)", width: "100" },
        { prop: "dispatchingWeight", label: "出库中(KG)", width: "100" },
        { prop: "balanceWeight", label: "仓单余额(KG)", width: "120" },
        { prop: "pledgeWeight", label: "质押数量(KG)", width: "120" },
        { prop: "loanAmount", label: "贷款金额(万元)", width: "120" },
        { prop: "operation", label: "操作", fixed: "right", width: 200 },
      ];
    },
  },
  methods: {
    ...mapMutations(["setTopSelectAreacode", "setTopSelectAreacodeArr"]),

    //获取粮食类别列表
    async fetchGrainCategoryList() {
      try {
        const res = await getGrainCategoryList({});
        if (res.data && Array.isArray(res.data)) {
          this.grainCategoryList = res.data;
          // console.log(res.data, 'res.data')
        } else {
          console.log("粮食类别列表数据格式不正确:", res.data);
        }
      } catch (error) {
        console.error("获取粮食类别列表失败", error);
      }
    },

    //获取仓单贷列表
    async fetchLoanList() {
      try {
        //左上角未选到市级别就用当前身份的到市级
        if (
          this.topSelectAreacode &&
          String(this.topSelectAreacode)?.length >= 4
        ) {
          this.areaCode = this.topSelectAreacode;
        } else {
          this.areaCode = getStore({ name: "identityObj" }).areaCode.slice(
            0,
            4
          );
        }
        this.areaCodeArr = splitStringByStep(this.areaCode);

        const res = await getLoanList({
          pnum: 1,
          psize: -1,
          areaCode: this.areaCode,
          status: 1,
        });
        // console.log('API Response111:',res)
        if (res.data && Array.isArray(res.data)) {
          this.loanList = res.data;
          // console.log(res.data, 'res.data')
        } else {
          console.log("仓单贷列表数据格式不正确:", res.data);
        }
      } catch (error) {
        console.error("获取仓单贷列表失败", error);
      }
    },

    // 获取表格数据
    async loadData(params = {}) {
      try {
        const apiParams = {
          pageNum: params.page || 1,
          pageSize: params.pageSize || 10,
          number: params.number || "",
          companyName: params.companyName || "",
          categoryId: params.categoryId || "",
        };
        const res = await getReceiptList(apiParams);
        // console.log('API Response:', res)

        const pageData = res.data;
        return {
          success: true,
          data: pageData?.list || [],
          total: Number(pageData?.total) || 0,
          page: Number(pageData?.pageNum) || 1,
          pageSize: Number(pageData?.pageSize) || 10,
        };
      } catch (error) {
        console.error("获取仓单列表失败", error);
        return {
          success: false,
          data: [],
          total: 0,
          page: 1,
          pageSize: 10,
        };
      }
    },

    viewLoanProductDetail(product) {
      // 查看贷款产品详情
      // console.log('查看贷款产品详情', product)
      this.$router.push({
        path: "/home/LoanDetails",
        query: {
          id: product.financeProductId,
        },
      });
    },

    handleMore() {
      // console.log('查看更多', this.areaCode, this.areaCodeArr)
      this.setTopSelectAreacode(this.areaCode);
      this.setTopSelectAreacodeArr(this.areaCodeArr);
      this.$router.push({
        name: "finance",
      });
    },

    handleInoutWarehouseRecord(row) {
      // 出入库记录操作
      console.log(row, "出入库记录操作");
      this.recordDialogVisible = true;
      this.currentDetail.id = row.id;
      // this.currentRecord = { id: row.id }; // 使用新对象
      // 调用接口获取记录数据
      // this.recordList = await api.getInoutRecords(row.id)
    },

    // 处理预约出库
    async handleAppointOutWarehouse(row) {
      this.selectedReceiptInfo = row;
      // 使用nextTick确保props更新后再打开弹窗
      await this.$nextTick();
      this.$refs.appointOutWarehouseModal.handleOpen();
    },

    // 处理预约出库确认
    handleAppointConfirm() {
      this.$message.success("预约出库成功！");
      // 刷新表格数据
      this.$refs.proTableRef?.refresh();
    },
  },
};
</script>

<style scoped lang="less">
.warehouse-receipt-management {
  padding: 20px;
  min-height: 100vh;
}

.loan-products {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.more {
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.product-item {
  width: calc(30% - 10px);
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 15px;
  background-color: #fff;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
}

.product-name {
  font-size: 16px;
  font-weight: bold;
  color: #ff7a45;
  margin-bottom: 5px;
}

.bank-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.product-info {
  margin-bottom: 15px;

  p {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;

    span {
      color: #333;
      font-weight: 500;
    }
  }
}

@media screen and (max-width: 1200px) {
  .product-item {
    width: calc(50% - 7.5px);
  }
}

@media screen and (max-width: 768px) {
  .product-item {
    width: 100%;
  }
}
</style>
